// extracted by mini-css-extract-plugin
module.exports = {"sideTab":"SideTab_sideTab__3RttL","active":"SideTab_active__3dBfQ","icon":"SideTab_icon__3_CT5","arrow":"SideTab_arrow__16H4B","body":"SideTab_body__20Siu"};